import { useState, useEffect, useRef } from "react";
import { Box, Typography, Button } from "@mui/material";
import { rsAddress, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import Barcode from "react-barcode";
import ReactToPrint from "react-to-print";
import { toMoney } from "../../util/Utils";
import { useSearchParams } from "react-router-dom";
import { UseOrders } from "../OrdersPage/UseOrders";

export default function FactorPrint(props) {
  const [msAddress, setMsAddress] = useRecoilState(rsAddress);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [data, setData] = useState();
  const componentRef = useRef();
  const [searchParams, setSearchParams] = useSearchParams();
  const { factorPrint } = UseOrders();

  const [factorPrints, setFactorPrint] = useState(
    localStorage.getItem("factorPrint")
      ? localStorage.getItem("factorPrint").replace(/['"]+/g, "")
      : ""
  );

  useEffect(() => {
    setMsAddress(true);
    setProgress(true);
    if (searchParams.get("oid")) {
      factorPrint(searchParams.get("oid"), (callback) => {
        setProgress(false);
        setData(callback);
      });
    }
  }, [searchParams]);

  return (
    data && (
      <>
        <ReactToPrint
          copyStyles={true}
          trigger={() => (
            <Button
              sx={{ m: 2, width: "100px" }}
              aria-label="Print Licensee profile"
              aria-haspopup="false"
              color="secondary"
              variant="contained"
            >
              چاپ
            </Button>
          )}
          content={() => componentRef.current}
        />
        <Box
          ref={componentRef}
          sx={{
            width: factorPrints && factorPrints == "A4" ? "29cm" : "14cm",
            m: 2,
            direction: "ltr",
          }}
        >
          <Box sx={{ height: "4cm" }}></Box>
          <Box
            sx={{
              my: 1,
              mt: 0,
              width: "100%",
              fontSize: factorPrints && factorPrints == "A5" && "11px",
            }}
          >
            <Typography
              sx={{
                textAlign: "center",
                fontSize: factorPrints && factorPrints == "A5" && "11px",
              }}
              fontWeight="bold"
              variant="body1"
            >
              صورتحساب فروش کالا
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              border: ".3px solid black",
              m: 2,
              mb: 0,
            }}
          >
            <Box sx={{ borderRight: ".3px solid black", width: 52 }}>
              <Typography
                fontWeight="bold"
                variant="body1"
                sx={{
                  transform: "rotate(-90deg)",
                  py: 3,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: factorPrints && factorPrints == "A5" && "11px",
                }}
              >
                فروشنده
              </Typography>
            </Box>
            <Box sx={{ width: "100%", px: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 1,
                }}
              >
                <Typography
                  sx={{
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                  variant="subtitle2"
                >
                  فروشنده : {data.seller}
                </Typography>
                <Typography
                  sx={{
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                  variant="subtitle2"
                >
                  {data.sellerLicenseTitle} {data.sellerLicense}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    width: "70%",
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                  variant="subtitle2"
                >
                  آدرس : {data.sellerAddress}
                </Typography>
                <Typography
                  sx={{
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                  variant="subtitle2"
                >
                  {data.sellerPhone}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              border: ".3px solid black",
              m: 2,
              mb: 0,
              mt: 0.5,
            }}
          >
            <Box sx={{ borderRight: ".3px solid black", width: 55 }}>
              <Typography
                fontWeight="bold"
                variant="body1"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: factorPrints && factorPrints == "A5" && "11px",
                  transform: "rotate(-90deg)",
                  py: 4,
                }}
              >
                خریدار
              </Typography>
            </Box>
            <Box
              sx={{
                borderRight: ".3px solid black",
                width: factorPrints && factorPrints == "A4" ? "85%" : "75%",
                p: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 1,
                }}
              >
                <Typography
                  sx={{
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                  variant="subtitle2"
                >
                  نام و نام خانوادگی : {data.fullName}
                </Typography>
                <Typography
                  sx={{
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                  variant="subtitle2"
                >
                  شماره تماس : {data.mobile}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                  variant="subtitle2"
                >
                  نشانی : {data.address}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: factorPrints && factorPrints == "A4" ? "15%" : "25%",
                p: 1,
                py: 2,
              }}
            >
              <Typography
                sx={{
                  fontSize: factorPrints && factorPrints == "A5" && "11px",
                  mb: 1,
                }}
                variant="subtitle2"
              >
                تاریخ : {data.shamsiLogDate}
              </Typography>
              <Barcode
                fontSize={factorPrints && factorPrints == "A5" ? 10 : 12}
                width={1.3}
                height={30}
                margin={0}
                value={data.id.toString()}
              />
            </Box>
          </Box>
          <Box
            sx={{
              border: ".3px solid black",
              m: 2,
              mt: 3,
            }}
          >
            <Box
              sx={{
                borderBottom: ".3px solid black",
                py: 1,
              }}
              display="grid"
              gridTemplateColumns="repeat(16, 1fr)"
              gap={1}
            >
              <Box gridColumn="span 1">
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "center",
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                >
                  ردیف
                </Typography>
              </Box>
              <Box gridColumn="span 8">
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "center",
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                >
                  نام محصول
                </Typography>
              </Box>
              <Box gridColumn="span 2">
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "center",
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                >
                  قیمت واحد
                </Typography>
              </Box>
              <Box gridColumn="span 2">
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "center",
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                >
                  قیمت با تخفیف
                </Typography>
              </Box>
              <Box gridColumn="span 1">
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "center",
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                >
                  تعداد
                </Typography>
              </Box>
              <Box gridColumn="span 2">
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "center",
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                >
                  جمع کل
                </Typography>
              </Box>
            </Box>
            {data &&
              data.orders.map((model, i) => {
                return (
                  <Box
                    key={i}
                    sx={{
                      borderBottom: ".3px solid black",

                      py: 1,
                    }}
                    display="grid"
                    gridTemplateColumns="repeat(16, 1fr)"
                    gap={1}
                  >
                    <Box gridColumn="span 1">
                      <Typography
                        variant="body2"
                        sx={{
                          textAlign: "center",
                          fontSize:
                            factorPrints && factorPrints == "A5" && "11px",
                        }}
                      >
                        {model.id}
                      </Typography>
                    </Box>
                    <Box gridColumn="span 8">
                      <Typography
                        variant="body2"
                        sx={{
                          textAlign: "left",
                          fontSize:
                            factorPrints && factorPrints == "A5" && "11px",
                        }}
                      >
                        {model.productName}
                      </Typography>
                    </Box>
                    <Box gridColumn="span 2">
                      <Typography
                        variant="body2"
                        sx={{
                          textAlign: "center",
                          fontSize:
                            factorPrints && factorPrints == "A5" && "11px",
                        }}
                      >
                        {model.cost ? toMoney(model.cost) : 0}
                      </Typography>
                    </Box>
                    <Box gridColumn="span 2">
                      <Typography
                        variant="body2"
                        sx={{
                          textAlign: "center",
                          fontSize:
                            factorPrints && factorPrints == "A5" && "11px",
                        }}
                      >
                        {model.discountCost ? toMoney(model.discountCost) : 0}
                      </Typography>
                    </Box>
                    <Box gridColumn="span 1">
                      <Typography
                        variant="body2"
                        sx={{
                          textAlign: "center",
                          fontSize:
                            factorPrints && factorPrints == "A5" && "11px",
                        }}
                      >
                        {model.orderCount}
                      </Typography>
                    </Box>
                    <Box gridColumn="span 2">
                      <Typography
                        variant="body2"
                        sx={{
                          textAlign: "center",
                          fontSize:
                            factorPrints && factorPrints == "A5" && "11px",
                        }}
                      >
                        {model.totalDiscountCost
                          ? toMoney(model.totalDiscountCost)
                          : 0}
                      </Typography>
                    </Box>
                  </Box>
                );
              })}
            <Box
              sx={{
                borderBottom: ".3px solid #e3e3e3",
                py: 0.5,
              }}
              display="grid"
              gridTemplateColumns="repeat(12, 1fr)"
              gap={1}
            >
              <Box gridColumn="span 9">
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "end",
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                >
                  قیمت :
                </Typography>
              </Box>
              <Box gridColumn="span 1">
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "end",
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                >
                  {data.totalCost ? toMoney(data.totalCost) : 0}
                </Typography>
              </Box>
              <Box gridColumn="span 2">
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "center",
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                >
                  تومان
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                borderBottom: ".3px solid #e3e3e3",

                py: 1,
              }}
              display="grid"
              gridTemplateColumns="repeat(12, 1fr)"
              gap={1}
            >
              <Box gridColumn="span 9">
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "end",
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                >
                  هزینه ارسال و بسته بندی :
                </Typography>
              </Box>
              <Box gridColumn="span 1">
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "end",
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                >
                  {data.deliveryCost ? toMoney(data.deliveryCost) : 0}
                </Typography>
              </Box>
              <Box gridColumn="span 2">
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "center",
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                >
                  تومان
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                borderBottom: ".3px solid #e3e3e3",

                py: 1,
              }}
              display="grid"
              gridTemplateColumns="repeat(12, 1fr)"
              gap={1}
            >
              <Box gridColumn="span 9">
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "end",
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                >
                  تخفیف مستقیم :
                </Typography>
              </Box>
              <Box gridColumn="span 1">
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "end",
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                >
                  {data.directDiscount ? toMoney(data.directDiscount) : 0}
                </Typography>
              </Box>
              <Box gridColumn="span 2">
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "center",
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                >
                  تومان
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                borderBottom: ".3px solid #e3e3e3",
                py: 1,
              }}
              display="grid"
              gridTemplateColumns="repeat(12, 1fr)"
              gap={1}
            >
              <Box gridColumn="span 9">
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "end",
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                >
                  کد تخفیف :
                </Typography>
              </Box>
              <Box gridColumn="span 1">
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "end",
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                >
                  {data.discountCodeCost ? toMoney(data.discountCodeCost) : 0}
                </Typography>
              </Box>
              <Box gridColumn="span 2">
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "center",
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                >
                  تومان
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                borderBottom: ".3px solid #e3e3e3",

                py: 1,
              }}
              display="grid"
              gridTemplateColumns="repeat(12, 1fr)"
              gap={1}
            >
              <Box gridColumn="span 9">
                <Typography
                  fontWeight="bold"
                  variant="body2"
                  sx={{
                    textAlign: "end",
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                >
                  مبلغ قابل پرداخت :
                </Typography>
              </Box>
              <Box gridColumn="span 1">
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "end",
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                >
                  {data.totalPayment ? toMoney(data.totalPayment) : 0}
                </Typography>
              </Box>
              <Box gridColumn="span 2">
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "center",
                    fontSize: factorPrints && factorPrints == "A5" && "11px",
                  }}
                >
                  تومان
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </>
    )
  );
}
